import React, { memo, forwardRef } from "react";
const SvgCapitalTau = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M10.176 7H21.48c.448 0 .752.112.912.336.176.224.264.464.264.72 0 .144-.024.288-.072.432-.048.128-.168.264-.36.408-.176.128-.424.192-.744.192h-4.464V22.84c0 .496-.128.848-.384 1.056a1.337 1.337 0 01-.816.288c-.272 0-.536-.096-.792-.288-.256-.208-.384-.56-.384-1.056V9.088h-4.464c-.448 0-.76-.112-.936-.336a1.182 1.182 0 01-.168-1.128c.048-.144.16-.28.336-.408.192-.144.448-.216.768-.216z"
      />
    </svg>
  );
});
SvgCapitalTau.displayName = "SvgCapitalTau";
const MemoForwardRef = memo(SvgCapitalTau);
export default MemoForwardRef;
